import React, { useState } from "react";
import styles from "./DropDown.module.scss";

const DropDown = ({ selected, setSelected, options, showRightIcon }) => {
  const [isActive, setIsActive] = useState(false);
  return (
    <div className={styles.dropdown}>
      <div
        className={styles.dropdownbtn}
        onClick={(e) => setIsActive(!isActive)}
      >
        {showRightIcon === false ? null : (
          <div className={styles.imgContainer}>
            <img className={styles.leftIcon} src={"/assets/amount.PNG"} />
          </div>
        )}
        <span>{selected}</span>
        <img className={styles.withRightIcon} src={"/assets/arrow-down.svg"} />
      </div>

      {isActive && (
        <div className={styles.dropdowncontent}>
          {options.map((option) => (
            <div
              onClick={(e) => {
                setSelected(option);
                setIsActive(false);
              }}
              className={styles.dropdownitems}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DropDown;
